module.exports = __webpack_public_path__ + "static/assets/870b8b39b077fc3423906a2e68b41245.png";